import { render, staticRenderFns } from "./LabelEditList.vue?vue&type=template&id=77cbef06&scoped=true&"
import script from "./LabelEditList.vue?vue&type=script&lang=ts&"
export * from "./LabelEditList.vue?vue&type=script&lang=ts&"
import style0 from "./LabelEditList.vue?vue&type=style&index=0&id=77cbef06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cbef06",
  null
  
)

export default component.exports